enum ROLES {
  USER = 'ROLE_USER',
  ADMIN = 'ROLE_ADMIN',
  COMMUNITY_MANAGER = 'ROLE_COMMUNITY_MANAGER',
  DEVELOPER = 'ROLE_DEVELOPER',
  GUEST = 'ROLE_GUEST',
  MODERATOR = 'ROLE_MODERATOR'
};

export default ROLES;
